import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { ContentCard, EmptyState, LoadingState, PageHeader, Section } from '../components/public/ui';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await api.get('/public/events');
        setEvents(response.data.data);
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  const tabs = [
    { label: 'Todos', filter: null },
    { label: 'Exámenes', filter: 'exam' },
    { label: 'Peleas', filter: 'fight' },
  ];

  const filteredEvents =
    tab === 0 ? events : events.filter((e) => e.event_type === tabs[tab].filter);

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('es-AR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  if (loading) {
    return <LoadingState />;
  }

  return (
    <Section className="section-pad">
      <PageHeader
        title="Eventos"
        lead="Exámenes, torneos y actividades de la escuela."
      />

      <div
        className="mb-8 flex gap-2 overflow-x-auto pb-1"
        role="tablist"
        aria-label="Filtrar eventos"
      >
        {tabs.map((item, index) => (
          <button
            key={item.label}
            type="button"
            role="tab"
            aria-selected={tab === index}
            className={`min-h-11 shrink-0 cursor-pointer rounded-full px-5 text-sm font-semibold transition-colors duration-200 ${
              tab === index
                ? 'bg-primary text-white'
                : 'border border-line bg-surface text-ink hover:border-primary'
            }`}
            onClick={() => setTab(index)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {filteredEvents.length === 0 ? (
        <EmptyState title="Sin eventos" description="No hay eventos para mostrar en este filtro." />
      ) : (
        <ul className="grid gap-4 md:grid-cols-2 lg:gap-6">
          {filteredEvents.map((event) => (
            <li key={event.id}>
              <ContentCard className="h-full">
                <div className="flex items-center justify-between gap-3">
                  <span
                    className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
                      event.event_type === 'exam'
                        ? 'bg-primary/10 text-primary'
                        : 'bg-ink text-white'
                    }`}
                  >
                    {event.event_type === 'exam' ? 'Examen' : 'Pelea'}
                  </span>
                  <time className="text-sm text-muted" dateTime={event.event_date}>
                    {formatDate(event.event_date)}
                  </time>
                </div>
                <h2 className="mt-4 font-display text-2xl font-semibold uppercase tracking-wide">
                  {event.title}
                </h2>
                <p className="mt-2 line-clamp-3 text-sm text-muted">{event.description}</p>
              </ContentCard>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
};

export default Events;
